import type { ComponentProps } from 'react';
import React from 'react';

import { getStepIndicatorItemAttrs } from '../../../utils/aria';
import { Flex } from '../../Flex';
import Details from './Details';
import Progress from './Progress';

type ItemProps = ComponentProps<typeof Progress> & ComponentProps<typeof Details>;

const Item = ({
  label,
  description,
  isFirst,
  isLast,
  isActive,
  isCompleted,
  isNextCompleted,
}: ItemProps) => (
  <Flex as="li" {...getStepIndicatorItemAttrs(isActive)}>
    <Progress
      isFirst={isFirst}
      isLast={isLast}
      isActive={isActive}
      isCompleted={isCompleted}
      isNextCompleted={isNextCompleted}
    />
    <Details
      isActive={isActive}
      isCompleted={isCompleted}
      label={label}
      description={description}
      isFirst={isFirst}
    />
  </Flex>
);

export default Item;
